import Monke from "../../img/2025/Frugo.jpeg";
const Puzzle4 = () => {
  return (
    <main style={{ padding: 24 }}>
      <h1>🍌 4. Frugo der Fruchtige – Das Kombinationsrätsel</h1>

      <p>
        Mmh… ich bin Frugo. Süß, saftig, fruchtig – und gefährlich logisch!
        Meine Rätsel sind wie Obstsalat: bunt gemischt, aber nur mit der
        richtigen Reihenfolge lecker. Probier’s aus!
      </p>
      <img src={Monke} style={{ maxWidth: "100%", marginBottom: "32px" }} />
      <p>
        <b style={{ fontSize: "1.2em" }}>
          🍎 + 🍌 = 8
          <br />
          🍌 + 🍊 = 10
          <br />
          🍊 + 🍎 = 12
          <br />
          Wie viel ist 🍌allein?
        </b>
      </p>
      <p>Ruso isst nur, wenn es kälter als 5°C ist… such ihn im Keller.</p>
    </main>
  );
};

export default Puzzle4;
